module.exports = __webpack_public_path__ + "img/scroll-arrow-up.37f01dbb.svg";